import { c as _c } from "react/compiler-runtime";
import Button from "@components/blocks/Button";
import CardButton from "@components/blocks/CardButton";
import Section from "@components/Section";
import SimpleRichText from "@components/SimpleRichText";
import { getSerifClass, isInverted } from "@components/utilities";
import { Title } from "@justhome/react-ui";
import clsx from "clsx";
import { FC } from "react";
import Icon from "./Icon";
import TextItems from "./TextItems";
import { CtaWithTextProps } from "./types";
const FirstVariant: FC<CtaWithTextProps> = t0 => {
  const $ = _c(61);
  const {
    data
  } = t0;
  const background = data.background;
  let T0;
  let T1;
  let inverted;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== background || $[1] !== data) {
    inverted = isInverted(background);
    T1 = Section;
    t6 = data;
    t7 = "rounded-m p-s pb-m m:p-3xl grid gap gap-y-none grid-cols-1 m:grid-cols-12";
    let t9;
    if ($[13] !== data.icon) {
      t9 = data.icon && <Icon icon={data.icon} />;
      $[13] = data.icon;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    if ($[15] !== t9) {
      t8 = <div className="m:col-span-12">{t9}</div>;
      $[15] = t9;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t5 = "col-span-1 m:col-span-5";
    t4 = "mb-3s m:mb-2m";
    T0 = Title;
    t1 = inverted;
    if ($[17] !== background) {
      t2 = getSerifClass(background);
      $[17] = background;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    t3 = clsx("text-d3", {
      "text-neutral-0": inverted
    });
    $[0] = background;
    $[1] = data;
    $[2] = T0;
    $[3] = T1;
    $[4] = inverted;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    T0 = $[2];
    T1 = $[3];
    inverted = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[19] !== T0 || $[20] !== data.title || $[21] !== t1 || $[22] !== t2 || $[23] !== t3) {
    t9 = <T0 inverted={t1} serifClass={t2} className={t3}>{data.title}</T0>;
    $[19] = T0;
    $[20] = data.title;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t4 || $[26] !== t9) {
    t10 = <div className={t4}>{t9}</div>;
    $[25] = t4;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== data.subTitle || $[29] !== inverted) {
    t11 = data.subTitle && <p className={clsx("text-body-1", {
      "text-neutral-0": inverted
    })}>{data.subTitle}</p>;
    $[28] = data.subTitle;
    $[29] = inverted;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t5) {
    t12 = <div className={t5}>{t10}{t11}</div>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t5;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== data.cardButton) {
    t13 = data.cardButton && <CardButton {...data.cardButton} />;
    $[35] = data.cardButton;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== data.button) {
    t14 = data.button && <Button {...data.button} />;
    $[37] = data.button;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== t13 || $[40] !== t14) {
    t15 = <div className="row-start-4 m:row-start-3 m:col-span-5 mt-3s m:self-end">{t13}{t14}</div>;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  const t16 = !inverted;
  let t17;
  if ($[42] !== inverted || $[43] !== t16) {
    t17 = clsx("m:row-span-2 m:col-span-6 m:col-start-7 divide-y divide-solid divide-opacity-20 flex flex-col", {
      "divide-neutral-675": t16,
      "divide-neutral-0/40": inverted
    });
    $[42] = inverted;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== data.body) {
    t18 = <div className="pb-2m flex-1"><SimpleRichText>{data.body}</SimpleRichText></div>;
    $[45] = data.body;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== data.textItems) {
    t19 = <TextItems items={data.textItems} />;
    $[47] = data.textItems;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t17 || $[50] !== t18 || $[51] !== t19) {
    t20 = <div className={t17}>{t18}{t19}</div>;
    $[49] = t17;
    $[50] = t18;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== T1 || $[54] !== t12 || $[55] !== t15 || $[56] !== t20 || $[57] !== t6 || $[58] !== t7 || $[59] !== t8) {
    t21 = <T1 section={t6} className={t7}>{t8}{t12}{t15}{t20}</T1>;
    $[53] = T1;
    $[54] = t12;
    $[55] = t15;
    $[56] = t20;
    $[57] = t6;
    $[58] = t7;
    $[59] = t8;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  return t21;
};
export default FirstVariant;